import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const SkeletonBase = styled.div<{ width?: string; height?: string, borderRadius?: string}>`
  background-color: ${({ theme }) => theme.colors.skeletonBase};
  border-radius: 4px;

  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.skeletonBase} 25%,
    ${({ theme }) => theme.colors.skeletonHighlight} 50%,
    ${({ theme }) => theme.colors.skeletonBase} 75%
  );
  
  background-size: 200% 100%;
  background-repeat: no-repeat;
  
  animation: ${shimmer} 3s infinite linear;
  
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '1rem'};
`;

export const TableSkeletonContainer = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.skeletonBorder};
  border-radius: 4px;
  overflow: hidden;
`;

export const SkeletonRow = styled(SkeletonBase)`
  height: 30px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.skeletonBorder};
  border-radius: 0;
`;

export const CardSkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
`;

export const SkeletonAvatar = styled(SkeletonBase)`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;

export const SkeletonTextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;